module.exports = __webpack_public_path__ + "static/img/manual_ja_28.b3f6cff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_28.png
// module id = qkPG
// module chunks = 4